module.exports = "<div class=q-v-align-children-middle> <span class=\"q-circle-icon q-ci-{%- statusColor %} fa fa-{%- icon %}\"></span> <span class=q-marg-left-xs>{%- ordStatus %}</span> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/proofOfDelivery/podShipmentSummary/html/renderTemplateForIconStatus.html
// module id = 1388
// module chunks = 1